import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "mr-s2"
}
const _hoisted_3 = {
  key: 1,
  class: "ml-s2"
}

import { computed } from 'vue';
import SwitchInput from './SwitchInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
    modelValue: { type: Boolean },
    name: null,
    labelOn: null,
    labelOff: null,
    labelPosOut: { type: Boolean },
    labelPosIn: { type: Boolean },
    namePos: null,
    color: null,
    size: null,
    checked: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: boolean): void;
  (e: 'change', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean;
  name?: string;
  labelOn?: string;
  labelOff?: string;
  labelPosOut?: boolean;
  labelPosIn?: boolean;
  namePos?: string;
  color?: string;
  size?: string;
  checked?: boolean;
  disabled?: boolean;
}





const isChecked = computed({
  get() {
    return props.modelValue;
  },
  set(value: boolean) {
    return emits('update:modelValue', value);
  },
});

const getCls = computed(() => {
  let cls = `switch-${props.color || 'light'}`;
  cls += props.disabled ? ' opacity-70' : '';
  cls += props.namePos === 'top' ? ' flex-column' : '';
  cls += props.size ? ' switch-' + props.size : '';
  return cls;
});

const handleChange = () => emits('change', isChecked.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inline-flex align-items-center", _unref(getCls)])
  }, [
    (__props.name && __props.namePos !== 'right')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([__props.namePos === 'top' ? 'mb-s2' : 'mr-s2', { 'text-muted': !_unref(isChecked) }])
        }, _toDisplayString(__props.name), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (__props.labelOff && __props.labelPosOut)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.labelOff), 1))
        : _createCommentVNode("", true),
      _createVNode(SwitchInput, {
        modelValue: _unref(isChecked),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isChecked) ? (isChecked).value = $event : null)),
        onChange: handleChange,
        "label-on": __props.labelPosIn ? __props.labelOn : '',
        "label-off": __props.labelPosIn ? __props.labelOff : '',
        class: _normalizeClass('switch-' + __props.color),
        disabled: __props.disabled
      }, null, 8, ["modelValue", "label-on", "label-off", "class", "disabled"]),
      (__props.labelOn && __props.labelPosOut)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.labelOn), 1))
        : _createCommentVNode("", true),
      (__props.namePos === 'right')
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["text-sm ml-s2", { 'text-muted': !_unref(isChecked) }])
          }, _toDisplayString(__props.name), 3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})